export default function (context) {
  const user = context.$auth.$storage.getState('user')

  if (user.roles.includes('designer')) return context.redirect('/kanban')
}
